module.exports = __webpack_public_path__ + "img/3x.10d94b0.jpg";